export default __webpack_public_path__ + "static/media/groupmember.fe627205.svg";